import { render, staticRenderFns } from "./pagingfy2.vue?vue&type=template&id=22a589d1&scoped=true&"
import script from "./pagingfy2.vue?vue&type=script&lang=js&"
export * from "./pagingfy2.vue?vue&type=script&lang=js&"
import style0 from "./pagingfy2.vue?vue&type=style&index=0&id=22a589d1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a589d1",
  null
  
)

export default component.exports